import { getIdToken } from "@/lib/platform/firebase";
import { trackEvent } from "@/lib/analytics/track";

export const AI_TOOLS_API_BASE = "https://www.nohaya.com/ai-tools/api";

export class AiToolError extends Error {
  status?: number;
  constructor(message: string, status?: number) {
    super(message);
    this.status = status;
  }
}

async function callRun(body: Record<string, unknown>): Promise<string> {
  trackEvent("ai_tool_click", { tool: body.tool });

  // Anonymous sign-in (same nohaya-platform identity CreatorVoice/Google
  // Sign-In use) gives every caller a stable uid, which is what the
  // 1-free-lifetime-use-per-tool cap on the PHP backend keys off — these
  // calls were fully unauthenticated before.
  const token = await getIdToken();
  const res = await fetch(`${AI_TOOLS_API_BASE}/run.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new AiToolError(data.message || `Request failed (${res.status})`, res.status);
  }
  return data.output as string;
}

export function runWriter(input: string, tone: string): Promise<string> {
  return callRun({ tool: "writer", input, tone });
}

export function runSummarizer(input: string, length: "short" | "medium" | "long"): Promise<string> {
  return callRun({ tool: "summarizer", input, length });
}

export function runTranslator(input: string, targetLanguage: string): Promise<string> {
  return callRun({ tool: "translator", input, targetLanguage });
}

export type ChatMessage = { role: "user" | "assistant"; content: string };

export function runChat(messages: ChatMessage[]): Promise<string> {
  return callRun({ tool: "chat", messages });
}
